module.exports = __webpack_public_path__ + "static/media/1-10.3f7c252e.mp3";